import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { TopNavbarComponent } from '../top-navbar/top-navbar.component';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [CommonModule, RouterModule, TopNavbarComponent]
})
export class MainComponent {
  constructor(public app: AppComponent) { }
  
}
